import React from 'react';
import { Button } from '../../components/Button';
import { Icon } from '../../components/Icon';
import { Tooltip } from '../../components/Tooltip';
import { identifyComponent } from '../../util';
import { InputGroup } from '../InputGroup';

export interface IconSet {
  id: string;
  name: React.ComponentProps<typeof Icon>['name'];
  title: string;
}

export interface IconToggleProps
  extends Pick<React.ComponentProps<typeof Button>, 'size' | 'testId' | 'disabled'> {
  options: IconSet[];
  selected: IconSet;
  onChange: (selected: IconSet) => void;
}

export const IconToggle: React.FC<IconToggleProps> = ({
  options,
  selected,
  onChange,
  size = 'medium',
  testId = 'icon-toggle',
  disabled = false,
}) => (
  <InputGroup
    data-component="IconToggle"
    data-testid={testId}
    {...identifyComponent('icon-toggle')}
  >
    {options.map(icon => {
      const isSelected = icon.id === selected.id;
      return (
        <Button
          testId={`${icon.id}-button`}
          key={icon.id}
          size={size}
          variant={isSelected ? 'fill-primary' : 'fill-builder'}
          onClick={() => onChange(icon)}
          disabled={disabled}
          aria-selected={isSelected}
        >
          <Tooltip
            placement="bottom"
            tooltipContent={icon.title}
            showDelay={300}
            persistDelay={0}
            offset={16}
            compact
            interactive={false}
          >
            <Icon name={icon.name} size={SIZE_TO_ICON_SIZE[size]} color="inherit" />
          </Tooltip>
        </Button>
      );
    })}
  </InputGroup>
);

const SIZE_TO_ICON_SIZE: {
  [key in NonNullable<React.ComponentProps<typeof Button>['size']>]: React.ComponentProps<
    typeof Icon
  >['size'];
} = {
  'x-small': 16,
  small: 16,
  medium: 20,
  large: 20,
};
